export const LAST_UPDATED = "15 юни 2026 г.";
export const CONTACT_EMAIL = "baggy.simandoff@gmail.com";
